/**
 * TargetingBorder - Unified targeting border component
 * Provides consistent yellow border with subtle pulsating effect for all targeting modes
 */

import React from 'react';
import './TargetingBorder.css';

/**
 * Get targeting border styles for inline use
 * @param {boolean} isActive - Whether targeting is active
 * @returns {Object|null} - Style object or null
 */
export function getTargetingBorderStyles(isActive) {
  if (!isActive) return null;
  
  return {
    border: '3px solid #ffff00',
    cursor: 'pointer',
    position: 'relative'
  };
}

/**
 * Get targeting border className for class-based styling
 * @param {boolean} isActive - Whether targeting is active
 * @returns {string} - ClassName string
 */
export function getTargetingBorderClassName(isActive) {
  return isActive ? 'targeting-border' : '';
}

/**
 * TargetingBorder wrapper component
 * Wraps children with targeting border styling when active
 * @param {Object} props
 * @param {boolean} props.isActive - Whether targeting is active
 * @param {React.ReactNode} props.children - Children to wrap
 * @param {Object} props.style - Additional inline styles
 * @param {string} props.className - Additional className
 */
export function TargetingBorder({ isActive, children, style = {}, className = '' }) {
  const combinedClassName = `${className} ${getTargetingBorderClassName(isActive)}`.trim();
  const combinedStyle = {
    ...style,
    ...getTargetingBorderStyles(isActive)
  };

  return (
    <div className={combinedClassName} style={combinedStyle}>
      {children}
    </div>
  );
}

export default TargetingBorder;

